export default __webpack_public_path__ + "static/bbq-full-01-710eed1b34f0922394681aaffb15d5fe.jpg";